import React from 'react';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';
import { Link } from 'react-router-dom';
import { imageUrl } from '../lib/images';

export default function About() {
  return (
    <>
      <SEO
        title="Fastlane ApS :: About Fastlane"
        description="Fastlane ApS er en logistik virksomhed i Danmark. Vi har stor viden og kompetencer indenfor almindelige transportformer i det meste af verdenen."
        canonicalUrl="https://fastlane.dk/om-os"
      />

      <PageHeader
        title="Om os"
        subtitle="Fastlane ApS er en logistikvirksomhed med base i Esbjerg og ekspertise i global spedition."
        breadcrumbs={[{ label: 'Om os' }]}
      />

      <div className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          {/* Main intro */}
          <div className="space-y-4 text-slate-700 leading-relaxed text-base sm:text-lg">
            <p>
              Fastlane ApS er en logistik virksomhed i Danmark. Vi har stor viden og kompetencer indenfor almindelige transportformer i det meste af verdenen.
            </p>
            <div className="pt-2">
              <Link
                to="/outsourcing"
                className="inline-flex items-center text-sm font-semibold text-sky-700 hover:text-sky-900 group"
              >
                <span>Hvorfor outsource via Fastlane ApS</span>
                <i className="fa-solid fa-arrow-right text-xs ml-2 group-hover:translate-x-1 transition-transform" aria-hidden="true" />
              </Link>
            </div>
          </div>

          {/* Medarbejdere */}
          <div>
            <h2 className="text-2xl font-bold text-[#0f2b48] border-b border-slate-200 pb-3 mb-8 flex items-center gap-2.5">
              <span className="w-2.5 h-2.5 rounded-full bg-[#c52828]" />
              Medarbejdere
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Arne Knudsen */}
              <div className="bg-slate-50 rounded-2xl p-6 border border-slate-200/90 shadow-2xs flex flex-col sm:flex-row items-center sm:items-start gap-6 text-center sm:text-left">
                <div className="w-32 h-32 rounded-xl overflow-hidden bg-slate-200 shrink-0 border border-slate-300/80 shadow-xs">
                  <img
                    src={imageUrl('https://assets.auxodev.dk/assets/2e6d0d1c-821d-400c-80aa-275c6c0c86cc/arne.png', 'width=300,height=300,fit=cover,format=auto')}
                    alt="Arne Knudsen"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="space-y-2">
                  <h3 className="text-xl font-bold text-[#0f2b48]">Arne Knudsen</h3>
                  <p className="text-sm font-semibold text-sky-700">Direktør</p>
                  <p className="text-sm">
                    <a href="mailto:ak@fastlane.dk" className="text-slate-600 hover:text-[#0f2b48] transition-colors whitespace-nowrap">
                      ak@fastlane.dk
                    </a>
                  </p>
                  <div className="pt-2">
                    <a
                      href="https://fastlane.dk/sites/default/files/akvcard.vcf"
                      download="Arne_Knudsen.vcf"
                      className="inline-flex items-center text-xs font-semibold text-sky-700 hover:text-sky-900 bg-white px-3 py-1.5 rounded-md border border-slate-200 shadow-2xs"
                    >
                      <i className="fa-solid fa-address-card mr-1.5 text-sky-600" aria-hidden="true" />
                      <span>Download my vCard</span>
                    </a>
                  </div>
                </div>
              </div>

              {/* Inger Holm */}
              <div className="bg-slate-50 rounded-2xl p-6 border border-slate-200/90 shadow-2xs flex flex-col sm:flex-row items-center sm:items-start gap-6 text-center sm:text-left">
                <div className="w-32 h-32 rounded-xl overflow-hidden bg-slate-200 shrink-0 border border-slate-300/80 shadow-xs">
                  <img
                    src={imageUrl('https://assets.auxodev.dk/assets/2e6d0d1c-821d-400c-80aa-275c6c0c86cc/inger.png', 'width=300,height=300,fit=cover,format=auto')}
                    alt="Inger Holm"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="space-y-2">
                  <h3 className="text-xl font-bold text-[#0f2b48]">Inger Holm</h3>
                  <p className="text-sm font-semibold text-sky-700">Bogholder</p>
                  <p className="text-sm">
                    <a href="mailto:ih@fastlane.dk" className="text-slate-600 hover:text-[#0f2b48] transition-colors whitespace-nowrap">
                      ih@fastlane.dk
                    </a>
                  </p>
                  <div className="pt-2">
                    <a
                      href="https://fastlane.dk/sites/default/files/ihvcard.vcf"
                      download="Inger_Holm.vcf"
                      className="inline-flex items-center text-xs font-semibold text-sky-700 hover:text-sky-900 bg-white px-3 py-1.5 rounded-md border border-slate-200 shadow-2xs"
                    >
                      <i className="fa-solid fa-address-card mr-1.5 text-sky-600" aria-hidden="true" />
                      <span>Download my vCard</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
